import React from 'react'
import PropTypes from 'prop-types'

const Beta = (props) => {
  const style = {
    color: props.color,
    display: 'inline',
    marginLeft: '0px'
  }

  return (
    <span style={style}>&nbsp;(beta)</span>
  )
}

Beta.propTypes = {
    color: PropTypes.string
}

export default Beta